import {
  START_FETCHING_ORDER_EVENT_HISTORY,
  SUCCESS_FETCHING_ORDER_EVENT_HISTORY,
  ERROR_FETCHING_ORDER_EVENT_HISTORY,
} from '@app/actions/order-event-history';

const initialState = {
  isFetching: false,
  orders: {},
};

const orderEventHistory = (state = initialState, action) => {
  switch (action.type) {
    case START_FETCHING_ORDER_EVENT_HISTORY:
      return {
        ...state,
        isFetching: true,
      };

    case ERROR_FETCHING_ORDER_EVENT_HISTORY:
      return {
        ...state,
        isFetching: false,
      };

    case SUCCESS_FETCHING_ORDER_EVENT_HISTORY:
      return {
        ...state,
        isFetching: false,
        orders: {
          ...state.orders,
          [action.orderId]: action.eventHistory,
        },
      };

    default:
      return state;
  }
};

export default orderEventHistory;



// WEBPACK FOOTER //
// ./src/reducer/order-event-history.js